module.exports = __webpack_public_path__ + "img/icon2.3cfb51b5.png";